export default "__VITE_ASSET__tKCcm23Y__"